import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { RichText } from 'prismic'

import { Row, Column12 } from 'components/ui/Grid'

import s from './RichTextSlice.module.scss'
const cn = classNames.bind(s)

const RichTextSlice = ({ data }) => (
  <div className={cn('richTextSlice')}>
    <Row>
      <Column12 initial={10} desktop={8} large={6} center>
        {RichText.render(data.primary?.text) || null}
      </Column12>
    </Row>
  </div>
)

RichTextSlice.propTypes = {
  data: PropTypes.exact({
    primary: PropTypes.object,
  }),
}

export default RichTextSlice
